/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AttendanceAuditLogShiftsResponse } from '../../models/attendance-audit-log-shifts-response';

export interface ListAttendanceAuditLogShifts$Params {
}

export function listAttendanceAuditLogShifts(http: HttpClient, rootUrl: string, params?: ListAttendanceAuditLogShifts$Params, context?: HttpContext): Observable<StrictHttpResponse<AttendanceAuditLogShiftsResponse>> {
  const rb = new RequestBuilder(rootUrl, listAttendanceAuditLogShifts.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AttendanceAuditLogShiftsResponse>;
    })
  );
}

listAttendanceAuditLogShifts.PATH = '/api/scheduler/attendance-audit-logs/shifts';
